import React from "react";

const NotFoundPage: React.FC = () => {
    return <div>Not Found</div>;
};

export default NotFoundPage;